import React, { useEffect } from 'react';
import {
    TextField,
    InputAdornment,
    Autocomplete,
    Box,
    Paper,
    Grid,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    CircularProgress,
    Tooltip,
    IconButton,
    Badge,
    // Checkbox
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import { makeStyles } from '@mui/styles';
import Title from '../title/title';
import { useState, Downgraded, createState } from '@hookstate/core';
import Helper from '../../utility/helper';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import SettingUserList from './settingUserList'
import SettingCustomDialog from '../dialog/settingDialog';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ConfirmationDialog from '../confirmationdialog/confirmationDialog';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import SettingConfirmationDialog from '../confirmationdialog/settingConfirmationDialog';
const useStyles = makeStyles({
    dialogContentRoot: {
        // maxHeight: 400,
        // overflowY: 'hidden',
        '&::-webkit-scrollbar': {
            width: '5px',
            height: '5px',
            backgroundColor: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#c1c1c1',
        },
    },
});
// const listStyle = {
//     width: '100%',
//     height: '200px',
//     overflowY: 'auto',
//     '&::-webkit-scrollbar': {
//         width: '5px',
//         height: '5px',
//         backgroundColor: '#f1f1f1',
//     },
//     '&::-webkit-scrollbar-thumb': {
//         background: '#c1c1c1',
//     },
// };
const hotelSettingState = createState({
    hotelComp: '',
    hotelPay: '',
});
const HotelSettingsDialog = (props) => {
    // console.log("props",props);
    const [search, setSearch] = React.useState('');
    const classes = useStyles();
    const tags = useState(null);
    const loading = useState(false);
    const selectedTags = useState([]);
    const eventInfo = useState(null);
    const userInfo = useState(null);
    const state = useState(hotelSettingState);
    const [compErr, setCompErr] = React.useState(false);
    const [payErr, setPayErr] = React.useState(false)
    const selectedUsers = useState([]);
    const [settingList, setSettingList] = React.useState([]);
    const [editID, setEditID] = React.useState(0)
    const [disableButton, setDisableButton] = React.useState(false)

    const deleteConfirmation = useState({
        open: false,
        title: '',
        message: '',
        deleteID: ''
    });
    const viewParticipantDialog = useState({
        open: false,
        title: '',
        message: [],
        tags: ''
    });

    useEffect(() => {
        state.set({
            hotelComp: '',
            hotelPay: '',
        })
        const userEventInfo = Helper.getStorage('eventInfo');
        const guserInfo = Helper.getStorage('userInfo');
        eventInfo.set(userEventInfo);
        userInfo.set(guserInfo);
        setRolesNTags(userEventInfo.eventID);
        getHotelSettingList(userEventInfo.eventID);
       
    }, []);
    // useEffect(() => {
    //     // const filters = tags.attach(Downgraded).get().filter((user) => user?.tagID !== selectedTags.attach(Downgraded).get()[0]?.tagID);
    //     // console.log("filters", filters);
    //     tags.attach(Downgraded).get().length > 0 ? tags.attach(Downgraded).get().filter((user) => 
    //         console.log(user)
    //         ) : null;
    //     // tags.set(filters)
    // },[selectedTags])
    const setRolesNTags = async (eventID) => {
        const rolesdata = ApiHelper.get(APIURLConstants.GET_ROLES(eventID));
        const tagsdata = ApiHelper.get(APIURLConstants.GET_TAGS(eventID));

        await Promise.all([rolesdata, tagsdata]).then((data) => {
            Helper.setStorage('userRoles', data[0].data);
            Helper.setStorage('userTags', data[1].data);
            const tagsd = data[1].data.filter((item) => item.status == 1);
            tags.set(tagsd);
        });
    };
    const getHotelSettingList = (eventID) => {
        loading.set(true)
        ApiHelper.get(APIURLConstants.GET_HOTEL_TICKET_SETTING(eventID, props.ModuleType))
            .then(res => {
                if (res.data) {
                    loading.set(false)
                    setSettingList(res.data.rows)
                    // console.log(res.data);
                }
            }).catch(err => {
                loading.set(false)
                console.log(err)
            });
    }
    const checkSelectedUsers = (value) => {
        // console.log(value);
        selectedTags.set([])
        selectedUsers.set(value);
    };
    // const ParticipantList = (props) => {
    //     const [participants, setParticipants] = React.useState([]);
    //     useEffect(() => {
    //         setParticipants(props.data);
    //         if (props.search) {
    //             let newCollectionTabs = [...props.data];
    //             let newUserData = newCollectionTabs.filter((user) => {
    //                 return (
    //                     user.name
    //                         .toLowerCase()
    //                         .indexOf(props.search.toLowerCase().trim()) > -1 ||
    //                     (user.userType && user.userType !== null && user.userType
    //                         .toLowerCase()
    //                         .indexOf(props.search.toLowerCase().trim()) > -1) ||
    //                     (user.userTags && user.userTags !== null && user.userTags
    //                         .toLowerCase()
    //                         .indexOf(props.search.toLowerCase().trim()) > -1)
    //                 );
    //             });
    //             setParticipants(newUserData);
    //         }
    //     }, []);

    //     return (
    //         <List sx={listStyle}>
    //             {participants &&
    //                 participants.map((item, index) => {
    //                     const labelId = `checkbox-list-label-${index}`;
    //                     return (
    //                         <ListItem key={`user_${index}`} disablePadding>
    //                             <ListItemButton
    //                                 // onClick={() => handleToggle(item)}
    //                                 dense>
    //                                 <ListItemIcon sx={{ height: '28px' }}>
    //                                     <Checkbox
    //                                         edge="start"
    //                                         // checked={
    //                                         //     selected
    //                                         //         .get()
    //                                         //         .indexOf(item.userID) !== -1
    //                                         // }
    //                                         tabIndex={-1}
    //                                         disableRipple
    //                                         inputProps={{
    //                                             'aria-labelledby': labelId,
    //                                         }}
    //                                     />
    //                                 </ListItemIcon>
    //                                 <ListItemText
    //                                     id={labelId}
    //                                     primary={item.name}
    //                                 />
    //                             </ListItemButton>
    //                         </ListItem>
    //                     );
    //                 })}
    //         </List>
    //     )
    // }
    const onHotelCompchange = (e) => {
        // console.log(e);
        e = Math.max(0, parseInt(e)).toString().slice(0, 7);

        state.set({
            ...state.get(),
            hotelComp: Number(e),
        });
        if (e === '' || isNaN(e)) {
            setCompErr('Please Enter Hotel Comp');
            return { flag: 'false' };
        } else if (e < 0) {
            setCompErr('Please Enter valid Hotel Comp');
            return { flag: 'false' };
        } else {
            setDisableButton(false)
            setCompErr('');
        }
    }
    const onHotelPayChange = (e) => {
        e = Math.max(0, parseInt(e)).toString().slice(0, 7)
        state.set({
            ...state.get(),
            hotelPay: Number(e),
        });
        if (e === '' || isNaN(e)) {
            setPayErr('Please Enter Hotel Pay');
            return { flag: 'false' };
        } else {
            setDisableButton(false)
            setPayErr('');
        }
    }
    const onTagsChange = (newValue) => {
        // console.log("newValue", newValue);
        selectedTags.set(newValue);
        // let newFiltervalue = [];
        // selectedTags.attach(Downgraded).get().map((value) => {
        //     tags.attach(Downgraded).get().map(value1 => {
        //         console.log("value.tagID !== value1.tagID","selectedTags",value.tagID,"tags",value1.tagID);
        //         if(value.tagID !== value1.tagID){
        //             newFiltervalue.push(value1)
        //         }
        //     }) 
        // })
        // newFiltervalue.length > 0 ? tags.set(newFiltervalue) : null
    }
    const handleClosed = () => {
        state.set({
            hotelComp: '',
            hotelPay: '',
        })
        props.handleClose();
    }
    // console.log("disableButton", tags.attach(Downgraded).get(), "users", tags.attach(Downgraded).get(), "selectedTags", selectedTags.attach(Downgraded).get());
    const renderDialogContent = () => (
        <>
            <Grid
                container
                alignItems="center"
                justify="center"
            >
                <Grid item align="center" xs={6}>
                    <TextField
                        size="small"
                        fullWidth={true}
                        placeholder="Search Individuals or Groups"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                        value={search}
                        onChange={(event) => setSearch(event.target.value)}
                    />
                    <Box >
                        <Paper>

                            <SettingUserList
                                search={search}
                                users={props.users}
                                checkUsers={checkSelectedUsers}
                                skipEventParticipants={null}
                                selectedUsers={selectedUsers.attach(Downgraded).get()}
                            />
                        </Paper>
                    </Box>
                </Grid>
                <Grid item align="center" xs={1}>
                </Grid>
                <Grid item align="center" xs={4}>
                    <Title
                        title="Add Tags"
                        sx={{
                            ml: 0,
                            pt: 1,
                            pb: 1,
                        }}
                        px={0}
                    />
                    {tags.get() ? (
                        <Autocomplete
                            multiple
                            id="size-small-standard-multi"
                            size="small"
                            options={tags.attach(Downgraded).get()}
                            getOptionLabel={(option) => option.tagName}
                            value={selectedTags.attach(Downgraded).get()}
                            onChange={(event, newValue) => {
                                onTagsChange(newValue)
                            }}
                            disabled={selectedUsers.attach(Downgraded).get().length > 0 ? true : false}
                            // defaultValue={[top100Films[1]]}
                            renderInput={(params) => (
                                <TextField {...params} placeholder="Tags" />
                            )}
                        />
                    ) : null}
                    <Box sx={{ marginTop: '10px' }}>

                        <TextField
                            fullWidth
                            required
                            sx={{
                                marginRight: 2,
                            }}
                            size="small"
                            id="outlined-required"
                            label="Hotel Comp"
                            type="number"
                            value={state.hotelComp.get()}
                            onChange={(e) => {
                                onHotelCompchange(e.target.value)
                            }}
                            error={compErr.length > 0 ? true : false}
                            helperText={compErr.length > 0 ? compErr : ''}
                        />
                    </Box>
                    <Box sx={{ marginTop: '10px' }}>

                        <TextField
                            fullWidth
                            required
                            sx={{
                                marginRight: 2,
                            }}
                            size="small"
                            id="outlined-required"
                            label="Hotel Pay"
                            type="number"
                            value={state.hotelPay.get()}
                            onChange={(e) => {
                                onHotelPayChange(e.target.value)
                            }}
                            error={payErr.length > 0 ? true : false}
                            helperText={payErr.length > 0 ? payErr : ''}
                        />
                    </Box>
                    <Box>
                        <ButtonContainer
                            handleClick={handleClick}
                            handleCancel={handleCancel}
                            buttonText={editID ? 'Edit' : 'Create'}
                            disableButton={disableButton ? true : false}
                        />
                    </Box>
                </Grid>
                <Grid item align="center" xs={1}>
                </Grid>

            </Grid>
            {
                <SettingConfirmationDialog
                    open={viewParticipantDialog.get().open}
                    message={viewParticipantDialog.attach(Downgraded).get().tags}
                    OkButtonText={viewParticipantDialog.get().OkButtonText}
                    handleCnfClick={() => { return true; }
                    }
                    onCancelClick={() => {
                        viewParticipantDialog.set({
                            ...viewParticipantDialog.get(),
                            open: false,
                        });
                    }}></SettingConfirmationDialog>
            }
            {
                <ConfirmationDialog
                    open={deleteConfirmation.get().open}
                    message={deleteConfirmation.get().message}
                    OkButtonText={deleteConfirmation.get().OkButtonText}
                    handleCnfClick={() =>
                        handleConfirmation(deleteConfirmation)
                    }
                    onCancelClick={() => {
                        deleteConfirmation.set({
                            ...deleteConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
        </>

    )
    const handleCancel = () => {
        state.set({
            hotelComp: '',
            hotelPay: '',
        })
        props.handleClose()
    }
    const handleClick = () => {
        const hComp = onHotelCompchange(state.hotelComp.get());
        const hPay = onHotelPayChange(state.hotelPay.get());

        if (hComp?.flag === 'false' || hPay?.flag === 'false') {
            return;
        }
        setDisableButton(true);
        // console.log("selectedUsers", selectedTags.get());

        let userIDs = [];
        if (selectedUsers.attach(Downgraded).get().length > 0) {
            let users = selectedUsers.attach(Downgraded).get();
            users.forEach((item) => {
                userIDs.push(item);
            });
        } else {
            let users = selectedTags.attach(Downgraded).get();
            users.forEach((item) => {
                userIDs.push(item.tagID ? item.tagID : item.participantID);
            });
        }

        const postSettingData = {
            hotelTicketSettingID: editID ? editID : 0,
            eventID: eventInfo.get().eventID,
            level: selectedUsers.attach(Downgraded).get().length > 0 ? 'P' : selectedTags.attach(Downgraded).get().length > 0 ? 'T' : 'E',
            iDs: userIDs.toString(),
            comp: state.get().hotelComp,
            pay: state.get().hotelPay,
            other: 0,
            type: props.ModuleType,
            modifiedBy: userInfo.get().userID
        }

        ApiHelper.post(APIURLConstants.POST_HOTEL_TICKET_SETTING, postSettingData)
            .then((res) => {
                // console.log("res", res);
                if (res.data) {
                    setDisableButton(false)
                    getHotelSettingList(eventInfo.get().eventID);
                    state.set({
                        hotelComp: "",
                        hotelPay: ""
                    })
                    selectedTags.set([])
                    selectedUsers.set([])
                    if (editID) {
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'success',
                            message: 'Hotel Setting updated successfully',
                        });
                    } else {
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'success',
                            message: 'Hotel Setting added successfully',
                        });
                    }
                    setEditID(0)
                }
            })
            .catch((error) => {
                setDisableButton(false)
                console.log(error);
            });
    }

    const editSetting = (data) => {
        setEditID(data.hotelTicketSettingID)
        let p = [];
        let t = [];
        data.hotelTicketParticipants.map((data) => {
            if (data.level === 'P') {
                p.push(data.participantID);
            } else if (data.level === 'T') {
                t.push(data.tagName);
            }
        })
        const tagsString = t.toString();
        const getTags = tags
            .attach(Downgraded)
            .get()
            .filter((item) =>
                tagsString.split(',').includes(item.tagName)
            );

        checkSelectedUsers(p)
        selectedTags.set(getTags)
        state.set({
            hotelComp: data.comp,
            hotelPay: data.pay
        })
    }

    const deleteSetting = (data) => {
        console.log(data);
        deleteConfirmation.set({
            open: true,
            title: '',
            OkButtonText: 'Ok',
            message: "Are you want to delete this Ticket?",
            deleteID: data.hotelTicketSettingID
        });

    }
    const handleConfirmation = () => {
        const postSettingData = {
            ids: deleteConfirmation.get().deleteID.toString(),
            modifiedBy: userInfo.get().userID
        }

        ApiHelper.post(APIURLConstants.DELETE_HOTEL_SETTING, postSettingData)
            .then((res) => {
                if (res.data) {
                    getHotelSettingList(eventInfo.get().eventID);
                    state.set({
                        hotelComp: "",
                        hotelPay: ""
                    })
                    selectedTags.set([])
                    selectedUsers.set([])
                    deleteConfirmation.set({
                        ...deleteConfirmation.get(),
                        open: false,
                    });
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Hotel Setting Deleted successfully',
                    });
                }
            }).catch((error) => {
                // let message = '';
                console.log(error);
            })
    };
    const handleViewParticipants = (names) => {

        viewParticipantDialog.set({
            ...viewParticipantDialog.get(),
            open: true,
            tags: names.hotelTicketParticipants
        });

    }
    const renderTableData = () => {
        return (
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table" size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center">participant</TableCell>
                            <TableCell align="center">Hotel Comp</TableCell>
                            <TableCell align="center">Hotel Pay</TableCell>
                            <TableCell align="center">Action</TableCell>
                        </TableRow>
                    </TableHead>
                    {loading.get() ? <TableBody >
                        <TableRow sx={{ height: "100px", textAlign: 'center' }}>
                            <TableCell colSpan={4} align="center"><CircularProgress /></TableCell>
                        </TableRow>
                    </TableBody> :
                        <TableBody>
                            {settingList && settingList.length > 0 ? settingList.map((value, i) => {
                                let partCount = 0;
                                value.hotelTicketParticipants.map(() => {
                                    partCount += 1
                                });
                                // console.log("value",value);
                                return (
                                    <TableRow
                                        key={i}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell align="center">
                                            <Tooltip title="View Participants or Tags" aria-label="view">
                                                <IconButton
                                                    color="primary"
                                                    onClick={() => handleViewParticipants(value)}
                                                // disabled={item.actualData.isPublic}
                                                >
                                                    <Badge badgeContent={partCount} color="primary">
                                                        <PeopleAltIcon
                                                            fontSize="small"
                                                            color={'default'
                                                                // item.actualData.isPublic
                                                                //     ? 'default'
                                                                //     : 'primary'
                                                            }
                                                        />
                                                    </Badge>
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                        <TableCell align="center">{value.comp}</TableCell>
                                        <TableCell align="center">{value.pay}</TableCell>
                                        <TableCell align="center">
                                            <EditIcon
                                                title="Edit"
                                                onClick={() => editSetting(value)}
                                                color="primary"
                                                sx={{ mr: 1, cursor: 'pointer' }}
                                            />
                                            <DeleteIcon
                                                title="Delete"
                                                color="primary"
                                                sx={{ ml: 1, cursor: 'pointer' }}
                                                onClick={() => deleteSetting(value)}
                                            />
                                        </TableCell>
                                    </TableRow>
                                )
                            }) : <TableRow>
                                <TableCell colSpan={4} align="center" component="th" scope="row"><b>No Record Found</b></TableCell>
                            </TableRow>}
                        </TableBody>}

                </Table>
            </TableContainer>
        )

    }

    return (
        <SettingCustomDialog
            title={props.title}
            handleClose={handleClosed}
            open={props.open}
            fullWidth={true}
            maxWidth={'lg'}
            renderContent={renderDialogContent}
            renderTableData={renderTableData}
            dialogContentClasses={{ root: classes.dialogContentRoot }}
        />
    );
};
export default HotelSettingsDialog;
